module.exports = __webpack_public_path__ + "edd7bf87e7e09451b38a1f1d5bd482a1.pdf";